export function closeWindow(): void {
  window.close();
}
